<template>
  <div class="users columns is-multiline is-mobile">
    <div class="user column is-mobile is-half-mobile is-one-quarter-tablet is-one-quarter-desktop is-one-fifth-widescreen" @click="view(user)" v-for="(user, index) in sortedUsers" :key="user.uuid" :class="{'user-card': useUserCard}">
      <user-card v-if="useUserCard && !limitScroll" :user="user"></user-card>
      <user-card v-if="useUserCard && limitScroll && index < limit" :user="user"></user-card>

      <div v-if="!useUserCard">
        <div class="image"><img v-if="user.avatar" :src="proxy(user.avatar)"></div>
        <div class="username">{{user.userName}}
          <span v-if="user.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
        </div>
        <div v-if="showRole" class="role">{{getRole(user)}}</div>
      </div>
    </div>
    <div class="loadMore" v-if="supportsLoading">
      <div class="loader" v-if="loading"></div>
      <div v-if="hasMore" @click="loadMore" class="button is-small is-outlined is-primary">{{ $t('loadMore') }}</div>
    </div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import UserCard from '@/components/Cards/UserCard'

export default {
  components: {
    UserCard
  },
  props: ['users', 'disableSort', 'hasMore', 'loading', 'loadMore', 'roles', 'useUserCard', 'limitScroll', 'limit'],
  data: function () {
    return {
      sortedUsers: []
    }
  },
  computed: {
    supportsLoading: function () {
      return !!this.loadMore
    },
    showRole: function () {
      return !!this.roles
    }
  },
  watch: {
    users: function (value) {
      this.sortUsers()
    }
  },
  mounted: function () {
    this.sortUsers()
  },
  methods: {
    sortUsers: function () {
      if (this.disableSort) {
        this.sortedUsers = this.users
        return
      }

      this.sortedUsers = [...this.users].sort((a, b) => {
        const scoreA = this.getRoleScore(a)
        const scoreB = this.getRoleScore(b)

        if (scoreA === scoreB) {
          return a.userName.localeCompare(b.userName)
        }

        return scoreA < scoreB ? -1 : 1
      })
    },
    getRole: function (user) {
      return this.roles ? this.roles[user.uuid] : ''
    },
    getRoleScore: function (user) {
      const role = this.getRole(user)
      switch (role) {
        case 'owner':
          return 1
        case 'co-owner':
          return 2
        case 'contributor':
          return 3
      }

      return 4
    },
    proxy: function (src) {
      return imageProxy.proxy(src, { width: 200, height: 200 })
    },
    view: function (user) {
      this.$router.push({ name: 'profile', params: { username: user.userName } })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.users {
  padding: 1rem;
  overflow: auto;

  @include mobile {
    padding: 1rem 0;
  }

  .loader {
    width: 100px;
    height: 100px;
    margin: auto;
    margin-top: 1rem;
  }

  .user {
    display: inline-flex;
    flex-flow: wrap;
    text-align: center;
    cursor: pointer;

    @include mobile {
      margin: 0;
    }

    .image {
      margin: auto;
      margin-bottom: 0.25rem;
      width: 5rem;
      height: 5rem;
      min-width: 5rem;
      max-width: 5rem;
      min-height: 5rem;
      max-height: 5rem;
      border-radius: 50%;
      border: 5px solid #FFF;

      img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        border-radius: 50%;
      }
    }

    .username {
      font-weight: bold;
      font-size: 0.87rem;
      @include mobile {
        font-size: 0.77rem;
      }
    }

    .role{
      font-size: 0.7rem;
      color: $grey;
    }
  }

  .loadMore {
    flex-basis: 100%;
    text-align: center;
    margin: 1rem 0;
  }
}

.user-card {
  padding: 0;
}

</style>
